/* maeda-en® - 2026/07/02 - Go to Top ボタン: スクロールで表示/非表示、クリックでスムーススクロール。
   ドッキング演出はJS不要（CSS側でボタンと同じright/bottom値をfooterのlower.svgに指定し、
   ページ最下部までスクロールすると座標が自然に一致する仕組み。詳細はassets/maeda-en-go-to-top.css参照） */
(function () {
  var button = document.getElementById('mae-gtt-button');
  if (!button) return;

  // ここを変えると表示が始まるスクロール量を調整できる（100 = 画面1個分スクロールしたら表示）
  var SHOW_AFTER_VIEWPORT_PERCENT = 100;
  var scrollTicking = false;

  function threshold() {
    return window.innerHeight * (SHOW_AFTER_VIEWPORT_PERCENT / 100);
  }

  // maeda-en® - 2026/07/13 - 閾値を超えてスクロールできる高さがあるページか（=スクロールで茶葉を出せるか）
  function canReveal() {
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    return maxScroll > threshold();
  }

  function updateVisibility() {
    // maeda-en® - 2026/07/13 - スクロールで茶葉を出せない短いページは常時表示にして、
    // カップだけが孤立するのを防ぐ（茶葉とカップを常に対で見せる）
    if (!canReveal() || window.scrollY > threshold()) {
      button.classList.add('is-visible');
    } else {
      button.classList.remove('is-visible');
    }
    scrollTicking = false;
  }

  function onScroll() {
    if (!scrollTicking) {
      scrollTicking = true;
      window.requestAnimationFrame(updateVisibility);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  // 画面リサイズや画像の遅延ロードで高さが変わり、短い⇔長いが切り替わり得るため再判定する
  window.addEventListener('resize', updateVisibility, { passive: true });
  window.addEventListener('load', updateVisibility);
  updateVisibility();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
